import React, { useMemo } from "react";
import { differenceInCalendarDays } from "date-fns";
import { Stack } from "@bookingcom/bui-react";
import { Text, Badge } from "@bookingcom/bui-react";
import styles from "./FlightCardSegmentRedesigned.mobile.module.css";
import { CardAirlineGroup } from "@flights/search-ui";
import { useCardCarriersCombinedController } from "./elements/CardCarriersCombined/useCardCarriersCombinedController.js";
import { useFormatDateTime } from "@bookingcom/flights-core";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import getTechnicalStops from "../../../../utils/get-technical-stops.js";
import { formattingUtils } from "@flights/web-api-utils-universal";
const FlightCardSegmentRedesignedMobile = ({ segment, idx }) => {
    return (React.createElement(Stack, { gap: 2, direction: "row", wrap: "nowrap" },
        React.createElement(Stack.Item, null,
            React.createElement(LogoAndTimeBlock, { segment: segment, idx: idx })),
        React.createElement(Stack.Item, { className: styles.stopsColumn, grow: true },
            React.createElement(Stops, { segment: segment, idx: idx }))));
};
const LogoAndTimeBlock = ({ segment, idx }) => {
    const { departureTime, departureAirport, arrivalTime, arrivalAirport } = segment;
    const i18n = useI18n();
    const { formats } = useFormatDateTime(i18n);
    const { carrierLogoCodes } = useCardCarriersCombinedController([segment]);
    const flightTimes = useMemo(() => {
        return [formats.flightTime(departureTime), formats.flightTime(arrivalTime)].join("-");
    }, [arrivalTime, departureTime, formats]);
    const daysDiff = differenceInCalendarDays(arrivalTime, departureTime);
    return (React.createElement(Stack, { gap: 4, direction: "row", wrap: "nowrap" },
        React.createElement(Stack.Item, { className: styles.logoColumn },
            React.createElement(CardAirlineGroup, { codes: carrierLogoCodes, size: 28 })),
        React.createElement(Stack.Item, null,
            React.createElement(Text, { variant: "strong_2", tagName: "strong", attributes: { "data-testid": `flight_card_segment_times_${idx}` } }, flightTimes),
            daysDiff === 0 ? null : (React.createElement(Text, { variant: "small_1", tagName: "span", attributes: { "data-testid": `flight_card_segment_days_diff_${idx}` } },
                daysDiff > 0 && "+",
                daysDiff)),
            React.createElement(Text, { variant: "small_1", className: styles.airports, attributes: { "data-testid": `flight_card_segment_airports_${idx}` } }, i18n.trans(t("flights_continue_search_card_title", {
                variables: { origin_city: departureAirport.code, destination_city: arrivalAirport.code }
            }))))));
};
const Stops = ({ segment, idx }) => {
    const { legs, totalTime } = segment;
    const i18n = useI18n();
    const totalTimeInMinutes = totalTime / 60;
    const stopsCount = legs.length - 1;
    const technicalStopsCount = getTechnicalStops.fromSegment(segment).length;
    return (React.createElement(React.Fragment, null,
        React.createElement(Badge, { text: stopsCount === 0
                ? i18n.trans(t("flights_filter_stops_none"))
                : i18n.trans(t("flights_route_num_stops", {
                    num_exception: stopsCount,
                    variables: { num_stops: stopsCount }
                })), variant: stopsCount === 0 ? "constructive" : "outline", attributes: { "data-testid": `flight_card_segment_stops_${idx}` } }),
        React.createElement(Text, { variant: "small_2", attributes: {
                "aria-label": formattingUtils.flightDurationAria(totalTimeInMinutes, i18n),
                "data-testid": `flight_card_segment_duration_${idx}`
            } }, formattingUtils.flightDuration(totalTimeInMinutes, i18n)),
        Boolean(technicalStopsCount) && (React.createElement(Text, { variant: "small_2" }, i18n.trans(t("flights_sr_technical_stop", {
            variables: {
                num_stop: technicalStopsCount,
                num_exception: technicalStopsCount
            }
        }))))));
};
export default FlightCardSegmentRedesignedMobile;
